import * as Yup from "yup";

export const crequest = Yup.object({
    amount: Yup.number()
    .label("Amount")
    .required("Please Enter Amount"),
});
